import {combineReducers} from 'redux';
import store from '../stores/store';
import _ from 'lodash';
import Moment from 'moment';

import {
  THREADS_ADD,
  THREADS_DELETE,
  THREADS_DELETED,
  THREADS_GET_MESSAGES,
  THREADS_INIT,
  THREADS_MESSAGE_ADD,
  THREADS_MESSAGE_DELETE,
  THREADS_MESSAGE_DELETED,
  THREADS_MESSAGE_IAM_TYPING,
  THREADS_MESSAGE_SUBMIT,
  THREADS_MESSAGE_USER_TYPING,
  THREADS_REFRESH,
  THREADS_SELECT,
  THREADS_SELECTED_HIDDEN_MSG,
  THREADS_SUBMIT,
  THREADS_TOOLBOXING
} from '../actions/threadsAction';

export default function (initialState={
  list:[],
  selectedThread: null,
  selectedThreadHiddenMsg: false,
  nbThreads: 0,
  whichToolboxOpened: null,
  typers: [],
  typing: {status: false, timerId: null, 'thread_id': null}
}, action) {

  switch (action.type) {
    case THREADS_INIT: {
      if (action.payload) {
        _.map(action.payload, (thread, index) => {
          if (thread.author.id === store.getState().luser.id) {
            action.payload[index].unanswered = false;
          }
        });

        return {
          ...initialState,
          list: action.payload,
          nbThreads: action.payload.length,
          selectedThread: null
        };
      }
      break;
    }

    case THREADS_REFRESH: {
      if (action.payload) {
        _.map(action.payload, (thread, index) => {
          if (thread.author.id === store.getState().luser.id) {
            action.payload[index].unanswered = false;
          }
        });

        return {
          ...initialState,
          list: action.payload,
          nbThreads: action.payload.length,
          selectedThread: store.getState().threads.selectedThread
        };
      }
      break;
    }

    case THREADS_SUBMIT: {
      // process a POST request into the chatMiddleware
      break;
    }

    case THREADS_ADD: {
      let threads = initialState.list;
      let new_thread = action.payload;
      new_thread.numberOfMessages = 0;
      if (new_thread.author.id === store.getState().luser.id) {
        new_thread.unanswered = false;
      }
      threads.push(new_thread);

      return {
        ...initialState,
        list: [...threads],
        nbThreads: threads.length
      };
    }

    case THREADS_SELECT: {
      let threads = initialState.list;
      const _selectedThread = action.thread;
      const _selectedThread_messages = _selectedThread.messages;

      // make the previous selected thread read before switching it
      if (initialState.selectedThread) {
        _.map(threads, (_thread, _index) => {
          if (_thread.id == initialState.selectedThread.id){
            threads[_index].read = true;
          }
        });
      }

      return {
        ...initialState,
        selectedThread: {
          ..._selectedThread,
          messages: [..._selectedThread_messages]
        },
        list: [...threads],
        typers: []
      };
    }

    case THREADS_MESSAGE_SUBMIT: {
      // process a POST request into the chatMiddleware
      break;
    }

    case THREADS_MESSAGE_ADD: {
      let threads = [...initialState.list];
      let selectedThread = { ...initialState.selectedThread };

      const thread_index = _.findIndex(threads, function(_thread) {
        return _thread.id === action.message.threadId;
      });

      if (threads[thread_index]) {
        threads[thread_index].touchedAt = Moment().toISOString();
        threads[thread_index].numberOfMessages += 1;

        if (!(action.message.author.insider)) {
          // no insider message, so checking if unanswered question inside the message
          if (action.message.body.match(/[a-z0-9]+\s*\?(\s|\r\n|\r|\n|$)+/)){
            threads[thread_index].unanswered = true;
          }
        } else {
          // if insider message, cancel the potential unanswered status
          threads[thread_index].unanswered = false;
        }

        // If the selected thread is the one we're adding a message to
        // we update it by pushing the new message
        if (selectedThread && selectedThread.id === threads[thread_index].id) {
          const updated = _.pick(
            threads[thread_index],
            ['touchedAt', 'numberOfMessages', 'unanswered']
          );

          selectedThread = { ...selectedThread, ...updated };
          selectedThread.messages.push(action.message);

          return { ...initialState, list: [...threads], selectedThread };
        } else {

          threads[thread_index].read = false;
          return { ...initialState, list: [...threads] };

        }
      }

      return initialState;
    }

    case THREADS_MESSAGE_USER_TYPING: {
      return {...initialState, typers: [...action.typers]};
    }

    case THREADS_MESSAGE_IAM_TYPING: {
      const _typing = initialState.typing;

      if (action.payload.status !== _typing.status) {
        return {...initialState, typing: { ..._typing, ...action.payload } };
      }

      break;
    }

    case THREADS_TOOLBOXING: {
      let whichToolboxOpened = action.payload;
      if (whichToolboxOpened == initialState.whichToolboxOpened) {
        whichToolboxOpened = null;
      }
      return { ...initialState, whichToolboxOpened };
    }

    case THREADS_DELETE: {
      // http delete request into chatMiddleware
      break;
    }

    case THREADS_DELETED: {
      if (action.thread_id) {
        let threads = [...initialState.list];
        let index_to_delete = null;

        _.map(threads, (thread, index) => {
          if (thread.id == action.thread_id) {
            index_to_delete = index;
            return;
          }
        });

        if (index_to_delete >= 0) {
          threads.splice(index_to_delete, 1);

          if (!threads.length) {
            threads = [];
          }
        }

        let selectedThread = initialState.selectedThread || null;

        if (!_.isEmpty(selectedThread) && (action.thread_id == selectedThread.id)) {
          selectedThread = null;
        }

        return {
          ...initialState,
          list: [...threads],
          nbThreads: threads.length,
          selectedThread
        };
      }
      break;
    }

    case THREADS_MESSAGE_DELETE: {
      // http delete request into chatMiddleware
      break;
    }
    case THREADS_MESSAGE_DELETED: {
      if (action.data.thread_id && action.data.message_id) {

        let threads = [...initialState.list];
        let selectedThread = {...initialState.selectedThread};

        var modified_thread = null;
        var modified_index_thread = null;

        // update the thread messages counter
        _.map(threads, (_thread, index) => {
          if (_thread.id == action.data.thread_id) {
            _thread.numberOfMessages -= 1;
            modified_thread = _thread;
            modified_index_thread = index;
            return;
          }
        });

        threads[ modified_index_thread ] = modified_thread;

        // if message is the selected one, update the messages list
        if (selectedThread && selectedThread.id == modified_thread.id){
          var message_index = null;
          _.map(selectedThread.messages, (_message, index) => {
            if (_message.id == action.data.message_id){
              message_index = index;
              return;
            }
          });
          if (message_index >= 0){
            selectedThread.messages.splice(message_index, 1);
            selectedThread.messages = (selectedThread.messages ? [...selectedThread.messages] : []);
            threads[ modified_index_thread ].messages.splice(message_index, 1);
            threads[ modified_index_thread ].messages = (threads[ modified_index_thread ].messages ? [...threads[ modified_index_thread ].messages] : []);
          }
        }

        return {
          ...initialState,
          list: [...threads],
          selectedThread: { ...selectedThread }
        };
      }
      break;
    }

    case THREADS_SELECTED_HIDDEN_MSG: {
      return { ...initialState, selectedThreadHiddenMsg: action.status };
    }
  }

  return initialState;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/threadsReducer.jsx